module.exports = __webpack_public_path__ + "img/social-feishu.e94cf65d.svg";